<template>
  <div>
    <Panel :class="panelwithCollapse">
      <template #header>
        <div class="grid">
          <div
            class="col-11 paddingTop10Px buttonCollapsePanel"
            @click="expandOrCollapse()"
          >
            <a class="buttonCollapsePanel">
              <span :class="expandClass"></span>
              <span class="titleHeader">
                <b>{{
                  $t("operacion.pagosCuenta.tituloHeader", {
                    numPagos: totalRecords,
                  })
                }}</b>
              </span>
            </a>
          </div>
          <div class="col-1">
            <Button
              v-tooltip.bottom="$t('operacion.pagosCuenta.botones.add')"
              @click.prevent="mostrarAlta()"
              class="
                visible
                p-button
                p-component
                p-button-icon-only
                p-button-rounded
                p-button-text
                rightAlign
                transparent
              "
              icon="pi pi-plus"
              iconPos="left"
            />
          </div>
        </div>
      </template>

      <DataTable
        v-show="this.totalRecords > 0"
        :value="pagosCuenta"
        :loading="loading"
        :lazy="true"
        :paginator="true"
        :rows="tamPagina"
        :totalRecords="totalRecords"
        class="p-datatable-responsive"
        :filters.sync="filters"
        selectionMode="single"
        dataKey="id"
        @page="onPage($event)"
        @sort="customSort($event)"
        :autoLayout="true"
      >
        <template #empty>
          {{ $t("common.noResultados") }}
        </template>

        <Column field="id" :header="$t('operacion.pagosCuenta.id')">
          <template #body="slotProps">
            <span class="p-column-title">{{
              $t("operacion.pagosCuenta.id")
            }}</span>
            {{ slotProps.data.id }}
          </template>
        </Column>

        <Column
          field="fechaPago"
          :header="$t('operacion.pagosCuenta.fechaPago')"
        >
          <template #body="slotProps">
            <span class="p-column-title">{{
              $t("operacion.pagosCuenta.fechaPago")
            }}</span>
            {{ getFormattedDateShort(slotProps.data.fechaPago) }}
          </template>
        </Column>

        <Column field="importe" :header="$t('operacion.pagosCuenta.importe')">
          <template #body="slotProps">
            <span class="p-column-title">{{
              $t("operacion.pagosCuenta.importe")
            }}</span>
            {{
              slotProps.data.importe
                | toCurrency("es-ES", slotProps.data.divisa)
            }}
          </template>
        </Column>

        <Column
          field="referenciaCliente"
          :header="$t('operacion.pagosCuenta.referenciaCliente')"
        >
          <template #body="slotProps">
            <span class="p-column-title">{{
              $t("operacion.pagosCuenta.referenciaCliente")
            }}</span>
            {{ slotProps.data.referenciaCliente }}
          </template>
        </Column>

        <Column field="usuario" :header="$t('operacion.pagosCuenta.usuario')">
          <template #body="slotProps">
            <span class="p-column-title">{{
              $t("operacion.pagosCuenta.referenciaCliente")
            }}</span>
            {{
              getFullNameByType(
                slotProps.data.usuario.nombre,
                slotProps.data.usuario.apellidos,
                slotProps.data.usuario.razonSocial,
                esEntidad(slotProps.data.usuario.tipo)
              )
            }}
          </template>
        </Column>
        <Column headerStyle="width: 10em"
          >>
          <template #header> </template>
          <template #body="slotProps">
            <Button
              @click.prevent="mostrarEditar(slotProps.data)"
              v-tooltip.bottom="$t('common.buttons.edit')"
              class="p-button leftAlign"
              icon="pi pi-pencil"
              iconPos="left"
              style="margin-right: 0.5em"
            />
            <Button
              @click.prevent="mostrarBorrar(slotProps.data)"
              v-tooltip.bottom="$t('common.buttons.eliminar')"
              class="p-button p-button-danger leftAlign paddingTopMinus5"
              icon="pi pi-trash"
              iconPos="left"
              style="margin-right: 0.5em"
            />
            <Button
              @click.prevent="mostrarAplicar(slotProps.data)"
              v-tooltip.bottom="$t('operacion.pagosCuenta.botones.aplicar')"
              class="p-button leftAlign paddingTopMinus5"
              icon="pi pi-paperclip"
              iconPos="left"
            />
          </template>
        </Column>
      </DataTable>
    </Panel>

    <AltaPagoCuenta
      :pagoCuenta="selectedPagoCuenta"
      :operacionToken="operacionToken"
      v-on:close-dialog="cerrarModal()"
      v-if="displayAlta"
      :displayAlta="displayAlta"
      :key="'AltaPagoCuenta' + displayAlta"
    />

    <AltaAplicado
      :pagoCuenta="selectedPagoCuenta"
      :operacionToken="operacionToken"
      :idOperacion="idOperacion"
      v-on:close-dialog="cerrarModal()"
      v-if="displayAplicar"
      :displayAlta="displayAplicar"
      :key="'AltaPagoCuenta' + displayAplicar"
    />

    <EditarPagoCuenta
      :pagoCuenta="selectedPagoCuenta"
      :operacionToken="operacionToken"
      v-on:close-dialog="cerrarModal()"
      v-if="displayEditar"
      :displayEditar="displayEditar"
      :key="'EditarPagoCuenta' + displayEditar"
    />

    <Confirmacion
      :header="$t('common.mensajes.confirmacionBorrado')"
      :mensajePre="$t('operacion.pagosCuenta.mensajes.borrado')"
      :mensajeNegrita="selectedPagoCuenta.id"
      mensajePost="?"
      :errores="errorConfirmacionBorrado"
      :displayConfirmation="displayConfirmation"
      v-on:confirmed="borrarPago(selectedPagoCuenta)"
      v-on:not-confirmed="cerrarModal()"
      v-if="selectedPagoCuenta"
      :key="'Confirmacion' + displayConfirmation"
    />
  </div>
</template>

<script>
import DatesMixin from "@/utils/dates";
import CurrencyMixin from "@/utils/currency";
import StringsMixin from "@/utils/strings";
import UsersMixin from "@/utils/users";
import AltaPagoCuenta from "@/components/portal-gran-cliente/editar/AltaPagoCuenta.vue";
import AltaAplicado from "@/components/portal-gran-cliente/editar/AltaAplicado.vue";
import EditarPagoCuenta from "@/components/portal-gran-cliente/editar/EditarPagoCuenta.vue";
import Confirmacion from "@/components/utilidades/Confirmacion.vue";
import { CLASS_COLLAPSED_ALL, CLASS_EXPANDED_ALL } from "@/resources/constants";
import {
  QUERY_GET_PAGOS_CUENTA,
  BORRAR_PAGOS_CUENTA,
} from "@/graphQLQueries/OperacionQueries";

export default {
  name: "ListadoPagosCuenta",
  components: {
    AltaPagoCuenta: AltaPagoCuenta,
    EditarPagoCuenta: EditarPagoCuenta,
    Confirmacion: Confirmacion,
    AltaAplicado: AltaAplicado,
  },
  props: ["operacionToken", "idOperacion"],
  mixins: [DatesMixin, CurrencyMixin, StringsMixin, UsersMixin],
  data() {
    return {
      numPagina: 0,
      tamPagina: 5,
      selectedPagoCuenta: null,
      sort: ["-fechaPago"],
      loading: false,
      totalRecords: 0,
      filters: {},
      panelwithCollapse: "panelwithCollapse collapsed",
      expandClass: CLASS_COLLAPSED_ALL,
      displayAlta: false,
      displayEditar: false,
      displayConfirmation: false,
      displayAplicar: false,
      errorConfirmacionBorrado: [],
    };
  },
  created() {
    this.loading = true;
  },
  computed: {
    backendFilters() {
      var filters2 = [];
      filters2.push(`operacion.token~eq=` + this.operacionToken);
      for (let [key, value] of Object.entries(this.filters)) {
        if (value != null && value != undefined && `${value}`) {
          filters2.push(`${key}~eq=${value}`);
        }
      }
      return filters2;
    },
  },
  methods: {
    search() {
      this.loading = true;
      setTimeout(() => this.$apollo.queries.pagosCuenta.refetch(), 500);
    },
    onPage(event) {
      this.numPagina = event.page;
    },
    mostrarAlta() {
      this.displayAlta = true;
    },
    mostrarEditar(selectedPagoCuenta) {
      this.selectedPagoCuenta = selectedPagoCuenta;
      this.displayEditar = true;
    },
    mostrarBorrar(selectedPagoCuenta) {
      this.selectedPagoCuenta = selectedPagoCuenta;
      this.displayConfirmation = true;
    },
    mostrarAplicar(selectedPagoCuenta) {
      this.selectedPagoCuenta = selectedPagoCuenta;
      this.displayAplicar = true;
    },
    cerrarModal() {
      this.displayAplicar = false;
      this.displayAlta = false;
      this.displayEditar = false;
      this.displayConfirmation = false;
      this.selectedPagoCuenta = null;
      this.errorConfirmacionBorrado = [];
      this.$emit("actulizar-importes", null);
      this.search();
    },
    expandOrCollapse() {
      this.expandClass.includes("pi-chevron-right") == true
        ? this.expandAll()
        : this.collapseAll();
    },
    expandAll() {
      this.expandClass = CLASS_EXPANDED_ALL;
      this.panelwithCollapse = "panelwithCollapse open";
      this.contentPanel = true;
    },
    collapseAll() {
      this.expandClass = CLASS_COLLAPSED_ALL;
      this.panelwithCollapse = "panelwithCollapse collapsed";
      this.contentPanel = false;
    },
    borrarPago(selectedPagoCuenta) {
      this.$apollo
        .mutate({
          mutation: BORRAR_PAGOS_CUENTA,
          variables: {
            borrarPagoCuentaRequest: {
              tokenOperacion: this.operacionToken,
              referenciaCliente: selectedPagoCuenta.referenciaCliente,
            },
          },
        })
        .then(() => {
          setTimeout(() => this.cerrarModal(), 500);
        })
        .catch((exception) => {
          this.errorConfirmacionBorrado = [];
          exception.graphQLErrors.forEach((error) => {
            this.errorConfirmacionBorrado.push(
              this.$i18n.t("contrato.errores." + error.message)
            );
          });
        });
    },
  },
  apollo: {
    pagosCuenta: {
      query: QUERY_GET_PAGOS_CUENTA,
      variables() {
        return {
          filter: this.backendFilters,
          sort: this.sort,
          page: this.numPagina,
          size: this.tamPagina,
        };
      },
      update(data) {
        this.loading = false;
        this.totalRecords = data.listaPagosCuenta.totalElements;
        return data.listaPagosCuenta.results;
      },
      fetchPolicy: "no-cache",
    },
  },
};
</script>


<style lang="scss" scoped>
</style>